import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Span,
  Label,
  Button,
  InnerPanel
} from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const ClickToCallContent = ({ content, onChange }) => {
  const attributes = content.attributes || [];

  const handleInstanceIdChange = instanceId => {
    onChange({ ...content, instanceId });
  };

  const handleContactFlowIdChange = contactFlowId => {
    onChange({ ...content, contactFlowId });
  };

  const handleSourcePhoneNumberChange = sourcePhoneNumber => {
    onChange({ ...content, sourcePhoneNumber });
  };

  const handleDestinationPhoneNumberChange = destinationPhoneNumber => {
    onChange({ ...content, destinationPhoneNumber });
  };

  const handleRegionChange = region => {
    onChange({ ...content, region });
  };

  const handleAttributeKeyChange = id => key => {
    onChange({
      ...content,
      attributes: attributes.map(attribute =>
        attribute.id === id ? { ...attribute, key } : attribute
      )
    });
  };

  const handleAttributeValueChange = id => value => {
    onChange({
      ...content,
      attributes: attributes.map(attribute =>
        attribute.id === id ? { ...attribute, value } : attribute
      )
    });
  };

  const handleAddAttribute = () => {
    onChange({
      ...content,
      attributes: attributes.concat({
        id: Math.random(),
        key: '',
        value: ''
      })
    });
  };

  const handleDeleteAttribute = id => () => {
    onChange({
      ...content,
      attributes: attributes.filter(attribute => attribute.id !== id)
    });
  };

  return (
    <Flex col fat="true" gap="sm">
      <Flex col fat>
        <Label>Instance ID*</Label>
        <TemplatingTextInput
          aria-label="Instance ID"
          placeholder="Instance ID"
          value={content.instanceId}
          onChange={handleInstanceIdChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Contact Flow ID*</Label>
        <TemplatingTextInput
          aria-label="Contact Flow ID"
          placeholder="Contact Flow ID"
          value={content.contactFlowId}
          onChange={handleContactFlowIdChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Source Phone Number*</Label>
        <TemplatingTextInput
          aria-label="Source Phone Number"
          placeholder="Source Phone Number"
          value={content.sourcePhoneNumber}
          onChange={handleSourcePhoneNumberChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Destination Phone Number*</Label>
        <TemplatingTextInput
          aria-label="Destination Phone Number"
          placeholder="Destination Phone Number"
          value={content.destinationPhoneNumber}
          onChange={handleDestinationPhoneNumberChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Region</Label>
        <TemplatingTextInput
          aria-label="Region"
          placeholder="Region (optional)"
          value={content.region}
          onChange={handleRegionChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Attributes</Label>
        {attributes.length === 0 && (
          <Span light mb>
            No attributes set
          </Span>
        )}
        {attributes.length > 0 && (
          <InnerPanel>
            {attributes.map((attribute, index) => (
              <Flex key={attribute.id} mb xSpace bottom>
                <Flex col fat>
                  {index === 0 && <Label>key</Label>}
                  <TemplatingTextInput
                    aria-label="Attribute key"
                    placeholder="Key"
                    value={attribute.key}
                    onChange={handleAttributeKeyChange(attribute.id)}
                  />
                </Flex>
                <Flex col fat>
                  {index === 0 && <Label>value</Label>}
                  <TemplatingTextInput
                    aria-label="Attribute value"
                    placeholder="Value"
                    value={attribute.value}
                    onChange={handleAttributeValueChange(attribute.id)}
                  />
                </Flex>
                <Flex bottom>
                  <Button
                    aria-label="Delete attribute"
                    icon="trash"
                    colour="danger"
                    onClick={handleDeleteAttribute(attribute.id)}
                  />
                </Flex>
              </Flex>
            ))}
          </InnerPanel>
        )}
        <Flex left>
          <Button icon="plus" onClick={handleAddAttribute}>
            Add attribute
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

ClickToCallContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    instanceId: PropTypes.string.isRequired,
    contactFlowId: PropTypes.string.isRequired,
    sourcePhoneNumber: PropTypes.string.isRequired,
    destinationPhoneNumber: PropTypes.string.isRequired,
    region: PropTypes.string,
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        key: PropTypes.string,
        value: PropTypes.string
      })
    )
  }).isRequired
};

export default ClickToCallContent;
